// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UpdateItemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/update_item/{item_id}
 *
 * Returns the id of the updated item.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_UpdateItemResponseDados {
item_id: number
}

export type Orders_UpdateItemResponse = ApiResponse<Orders_UpdateItemResponseDados>;

registerResponseContract('Orders_UpdateItemResponse', {
  item_id: { type: 'number',  required: true },
})
